<div class="page-header">
  <h3 class="page-title">{{'workflow' | translate}}</h3>
</div>

<div class="card">
  <div class="card-body">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>{{'roleName' | translate}}</th>
          <th>{{'requestAction' | translate}}</th>
          <th>{{'fromStatus' | translate}}</th>
          <th>{{'toStatus' | translate}}</th>
          <th>{{'isActive' | translate}}</th>
          <th>{{'isServiceWorkflow' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let wf of workflows; let i = index">
          <td>{{i + 1}}</td>
          <td>{{wf.role?.name || wf.roleName}}</td>
          <td>{{wf.requestActionName}}</td>
          <td>{{wf.requestFromStatus?.name || wf.fromStatusName}}</td>
          <td>{{wf.requestToStatus?.name || wf.toStatusName}}</td>
          <td>{{wf.isActive}}</td>
          <td>{{wf.isServiceWorkflow}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
